import { render, staticRenderFns } from "./GridItemAdd.vue?vue&type=template&id=caccacda&scoped=true"
import script from "./GridItemAdd.vue?vue&type=script&lang=js"
export * from "./GridItemAdd.vue?vue&type=script&lang=js"
import style0 from "./GridItemAdd.vue?vue&type=style&index=0&id=caccacda&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caccacda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caccacda')) {
      api.createRecord('caccacda', component.options)
    } else {
      api.reload('caccacda', component.options)
    }
    module.hot.accept("./GridItemAdd.vue?vue&type=template&id=caccacda&scoped=true", function () {
      api.rerender('caccacda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/file-browser-product-selector/browser/GridItemAdd.vue"
export default component.exports